import ContactAddressPage from './contact-address-page'

export default ContactAddressPage